import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import { Result, Button } from 'antd';
import { Switch, Route, Link } from "react-router-dom";

import Home from './layout/Home';
import Event from './layout/Event';

import './App.css';

import * as locale from './locale';


const returnWindowLanguage = () => {
  if(navigator.language === 'ko' || navigator.language === 'ko-KR')
    return 'ko'
  else {
    return 'en'
  }
}

function App() { 

  const [ language, setLanguage ] = useState('en');

  return (
    <IntlProvider locale={language} messages={locale[language]}>
      <Switch>
        <Route exact path="/" >
          <Home language={language} changeLanguage={(language) => setLanguage(language)}/>
        </Route>
        <Route path="/home" >
          <Home language={language} changeLanguage={(language) => setLanguage(language)}/>
        </Route>
        <Route path="/event" >
          <Event/>
        </Route>
        <Route path="*">
          <NoMatch />
        </Route>
      </Switch>
    </IntlProvider>
  );
}

function NoMatch() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={<Link to="/home"><Button type="primary">Back Home</Button></Link>}
      />
  );
}


export default App;
